/**
 * Sphere geometry. The wall's original (baseline) diameter is the width of an
 * `auto-fill, minmax(var(--disc-min), 1fr)` column — two fixed columns on phones.
 * Spheres render at `--sphere-scale` (tokens.css) of that baseline, so the
 * reduction is applied exactly once and never compounds across renders.
 */
export const MOBILE_QUERY = '(max-width: 639px)';
const MOBILE_COLUMNS = 2;

export function baselineDiameter(containerWidth: number, discMin: number, gap: number, mobile: boolean): number {
  if (containerWidth <= 0) return 0;
  const columns = mobile
    ? MOBILE_COLUMNS
    : Math.max(1, Math.floor((containerWidth + gap) / (Math.max(1, discMin) + gap)));
  return (containerWidth - gap * (columns - 1)) / columns;
}

export function sphereScale(el: Element): number {
  const value = parseFloat(getComputedStyle(el).getPropertyValue('--sphere-scale'));
  return Number.isFinite(value) && value > 0 ? value : 1;
}

/** Writes `--sphere-d` (px) on the grid from its own width and the resolved `--disc-min` of the probe. */
export function applySphereDiameter(grid: HTMLElement, probe: HTMLElement): number {
  const styles = getComputedStyle(grid);
  const gap = parseFloat(styles.columnGap) || 0;
  const width = grid.clientWidth;
  const mobile = window.matchMedia(MOBILE_QUERY).matches;
  const diameter = baselineDiameter(width, probe.offsetWidth, gap, mobile) * sphereScale(grid);
  if (diameter > 0) grid.style.setProperty('--sphere-d', `${diameter.toFixed(3)}px`);
  return diameter;
}
